/**
 * Linked list node
 */
export interface DoublyLinkedListNode {
  value: any;
  next?: DoublyLinkedListNode;
  prev?: DoublyLinkedListNode;
}
export interface VersionNode {
  value: any;
  storydata: any;
  elementindex: any;
  elementdata: any;
  indexatelement: any;
  type: any;
}
/**
 * Linked list for items of type any
 */
export class VersioningTree {
  public versionArray = [];
  public head = -1;
  public tail = -1;
  addItem(item) {
    if (this.head === -1) {
      this.versionArray = [item];
      this.head = 0;
      this.tail = 0;
    } else if (this.head === 295) {
      console.log('reached 295');
      this.versionArray.splice(0, 50);
      this.tail = 0;
      this.head = this.head - 50;
      this.addItem(item);
    } else {
      this.versionArray.push(item);
      this.head += 1;
      if (this.head > 0) {
        const diff = (this.versionArray.length - this.head) - 1;
        if (diff > 0) {
          this.versionArray.splice((this.head), diff);
        }
      }
    }
  }
  redo() {
    const nexthead = this.head + 1;
    if (this.versionArray[nexthead]) {
      this.head += 1;
      return this.versionArray[nexthead];
    } else {
      return false;
    }
  }
  undo() {
    const lasthead = this.head;
    this.head -= 1;
    return this.versionArray[lasthead];
  }
  dequeTree() {
    const lasttail = this.versionArray[0];
    this.versionArray.splice(0, 1);
    this.tail = 0;
    this.head -= 1;
    return lasttail;
  }
}
